import React, { useId, useLayoutEffect, useState } from "react";
import { Box, Text, Tooltip } from "@shopify/polaris";

export function LocationColumnHeading({ title }: { readonly title: string }): React.ReactElement {
  const textId = useId();
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const textElement = document.getElementById(textId);
    setIsTruncated(textElement.scrollWidth > textElement.clientWidth);
  }, [textId, title]);

  const text = (
    <Text as="span" id={textId} truncate>
      {title}
    </Text>
  );

  return (
    <Box maxWidth="190px" width="fit-content">
      {isTruncated ? <Tooltip activatorWrapper="div" content={title} hasUnderline>{text}</Tooltip> : text}
    </Box>
  );
}
